<template>
  <div class="infomationContent">
    <Nav  ref="navRef" @changeLogin='changeLogin'></Nav>
    <div style="max-width: 1200px;width: 100%;height:80px;"></div>
    <div class="line_tabs">
        <div>首页</div>
        <i style="margin: 0 4px;" class="el-icon-arrow-right"></i>
        <div style="color: #721EDC;">
         {{articleInfo.annTitle}}
        </div>
    </div>
    <div class="contentlist">
      <div class="left_box"  v-infinite-scroll="load" style="overflow-y:scroll">
         <div class="article_details" :loading='!articleInfo.annTitle'>
            <div  class="art_title"  v-if="articleInfo.annTitle">
            	{{articleInfo.annTitle}}
            </div>
            <div class="userData"  v-if="articleInfo.annTitle">
            	<div class="uheader">
            		<img :src="userinfo.avatar" mode=""/>
            	</div>
            	<div class="uname">
            		<div class="name">{{userinfo.nickname}}</div>
            		<div style="color: #999999;font-size: 13px;margin-top:2px;">{{fifTime( articleInfo.publishTime )}}</div>
            	</div>
            </div>
            <div class="newsContent">
            	<div v-html="articleInfo.annContent"></div>
            </div>
         </div>
          <div class="emittxt">
           —— 加载到底了 ——
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Nav from '@/component/Nav'
  import $ from 'jquery'
  import moment from 'moment'
  import {announcementdetail,announcementlist} from '@/api/video.js'
  export default {
    data() {
      return {
        key: 'value',
        infomationdetails:[],
        firstReqTime:'',
        deviceIdentify:'',
        articleInfo:{},
        userinfoData:{
          avatar:''
        },
        // 评论相关
        commentReplytxt:'',
        UserInfo:{},
        commentReplytxt2:'',
        videoCurrentList:'',
        revewList:[],
        readem:'',
        aboutnews:[],
        announcementId:''
      }
    },
    created() {
      let articleId = this.$route.query.aid;
      if(articleId){
        this.announcementId = articleId;
        this.initData();
      }
      console.log('文章参数',articleId);
    },
    methods:{
      load(){

      },
      changeLogin(){
        this.initData()
      },
      // 更多资讯
      loadnews(){
        this.$router.push({
          path: "/informationlist",
        })
      },
      // 新闻页面
      navDetails(val){
        console.log(val);
         this.initData();
      },
      async initData(){
        announcementdetail({announcementId:this.announcementId}).then(res=>{
          if(res.data.code ==200){
            this.articleInfo = res.data.data;
            this.userinfo = res.data.data.publishUserData;
            this.articleInfo.annContent = this.articleInfo.annContent.replace(/<pre>|<\/pre>/ig,'');
            this.articleInfo.annContent =  this.articleInfo.annContent.replace(/(href)/ig,'b');
            console.log('加载',this.articleInfo);
          }
        })
      },
      // 回复内容
      setreadem(item){
        this.readem = item.commentId;
        item.edit = true;
      },
      // 展开回复
      openchild(item){
        console.log('展开了吗',item);
        // 获取二级评论
        if(item.showchild === 1 || item.showchild == false){
          this.getChildCommentList(item);
          item.showchild = true;
        }else{
          item.showchild = false;
        }

      },
      // 获取一级评论
      async getCommnetreply(){
        let result = await getcommentList({
          articleId:this.articleInfo.articleId,
          firstReqTime:this.firstReqTime,
          sortOrder:'',
          page:1,
          limit:100,
        })
        console.log('一级评论列表', result.data.data);
            if(result.data.code == 200){
              this.firstReqTime = result.data.data.firstReqTime;
              let list = result.data.data.list;
              this.revewList = list.map(item=>{
                item.edit = false;
                item.showchild = 1;
                return item
              })
              this.$forceUpdate()
            }
      },
      // 评论二级内容
     async comentplay2(values,val){
        if(this.commentReplytxt2 =='' || !this.commentReplytxt2){
          this.$message.error('评论内容不能为空~');
          return
        }
        if(!localStorage.getItem("token")){
          this.$refs.navRef.Longin();
          this.$message.error('请登录后评论')
          return
        }

        let keyWord = await  this.$store.dispatch('fifWord',{key:"commonSendlist",value:this.commentReplytxt2})
        if(keyWord.state){
          this.commentReplytxt2 = keyWord.value;
        }else{
          return
        }




        operationcommentReply({
          articleId:this.articleInfo.articleId,
          commentContent:this.commentReplytxt2,
          commentId:val.commentId,
          toUId:val.uId,
          replyType:1,
        }).then(res=>{
          console.log('这是二级评论',values);
          if(res.data.code == 200){
            this.firstReqTime = ''
            this.$message.success('评论成功');
            if(values){
              this.getChildCommentList(values)
            }else{
              this.getChildCommentList(val)
            }
            this.commentReplytxt2 = ''
          }
        })
      },
      // 获取二级评论
      getChildCommentList(val){
        articlechildCommentList({
        	articleId:this.articleInfo.articleId,
        	commentId:val.commentId,
        	firstReqTime:this.firstReqTime,
        	page:1,
        	limit:100,
        }).then(result=>{
          if(result.data.code ==200){
              let index = this.revewList.findIndex(item=>item.commentId==val.commentId);
              this.firstReqTime = result.data.data.firstReqTime;
              let arr =  result.data.data.list;
              this.revewList[index].childCommentList = arr.map(item=>{
                item.edit = false;
                return item
              })
              console.log('二级评论',index, this.revewList[index].childCommentList);
              this.$forceUpdate()
              this.revewList[index].showchild = true;
          }
        })
      },
     // 评论当前新闻
     async replyCurrentVideo(){
       if(this.commentReplytxt =='' || !this.commentReplytxt){
         this.$message.error('评论内容不能为空~');
         return
       }

      if(!localStorage.getItem("token")){
        this.$message.error('请登录后评论')
        this.$refs.navRef.Longin();
        return
      }

       this.firstReqTime = '';

       //
      let keyWord = await  this.$store.dispatch('fifWord',{key:"commonSendlist",value:this.commentReplytxt})
      if(keyWord.state){
        this.commentReplytxt = keyWord.value;
      }else{
        return
      }

       // 过滤敏感词


       operationcomment({
         articleId:this.articleInfo.articleId ,
         commentContent:this.commentReplytxt,
       }).then(res=>{
          if(res.data.code == 200){
            this.getCommnetreply();
            this.commentReplytxt = '';
            console.log('评论成功',res);
          }else{
            this.$message.error(res.data.message)
          }

       })
     },
      fifTime(val){
      	let t1= moment(val * 1000);
      	let t2 = moment();
      	let status = '';
      	if(t2.diff(t1, 'day') > 0){
      	  let days =  t2.diff(t1, 'day');
      	  if(days >= 4){
      	    return moment(val * 1000).format('YYYY-MM-DD')
      	  }else{
      	    status = days +'天前'
      	    return status
      	  }

      	}
      	if(t2.diff(t1, 'hour') > 0){
      		status = t2.diff(t1, 'hour') +'小时前'
      		return status
      	}

      	if(t2.diff(t1, 'minutes') > 0){
      		status = t2.diff(t1, 'minutes') +'分钟前'
      		return status
      	}
      	if(t2.diff(t1, 'seconds') >= 0){
      		status = '刚刚'
      		return status
      	}
      	console.log();//实际相差多少天 ， 第二个参数是单位


      	 // moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
      },
    },
    components:{
      Nav
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../assets/style/flex.scss';
  .newsContent{
  	margin-bottom:32rpx;
    div{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 20px;

    }
  }
  .replayComent{

    .userrevewinfo {
      margin-top: 24px;

      .revewdata {
        flex: 2;
        padding: 10px 12px;
      }

      .btnclickmsg {
        cursor: pointer;
        position: absolute;
        right: 20px;
        bottom: 50%;
        transform: translateY(50%);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #721EDC;
      }

      .succendsendmsg {
        margin-top: 12px;
        flex: 2;

        img {
          width: 32px;
          height: 32px;
          background: #DADADA;
          border-radius: 50%;
        }

        .editinput {
          position: relative;
          flex: 2;
          margin-left: 12px;
        }
      }

      .revewcnt {
        margin-top: 12px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        .trange{
          transform: rotate(180deg);
          transition: all .2s;
        }
        .handlerevew {
          max-width: 160px;
          margin-top: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          img {
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }

          span {
            // height: 35px;
            align-items: center;
            display: flex;
            font-size: 12px;
            cursor: pointer;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
      }

      .usertitle {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;

        .datastatus {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
        }
      }

      .userinfoimg {
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
        }
      }
    }

    .smalltitle {
      margin-top: 50px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    .btnsendmsg {
      display: flex;
      justify-content: flex-end;
      .bgactive{
        background-color: #721EDC;
      }
      span {
        text-align: center;
        cursor: pointer;
        width: 64px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        background: #B3B3B3;
        border-radius: 4px 6px 6px 4px;
      }
    }

    .sendmsg {
      margin-top: 24px;

      img {
        width: 60px;
        height: 60px;
        background: #DADADA;
        border-radius: 50%;
      }

      .editinput {
        flex: 2;
        margin-left: 12px;
      }
    }
  }
  .ouvecommons{
    margin: 32px 0;
  	font-size: 20px;
  	font-family: PingFangSC-Medium, PingFang SC;
  	font-weight: 500;
  	color: #721EDC;
  	display: flex;
  	align-items: center;
  	justify-content: center;
  	span{
  		margin:0 10px;
  		width: 60px;
  		height: 1px;
  		background-color:#721EDC ;
  		opacity: 0.5;
  	}
  }
  .infomationContent{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    // height: calc(100vh - 80px);
    background: #F7F8FA;

    /*每个页面公共css */
    .myfont1 {
    	overflow: hidden; //隐藏文字
    	text-overflow: ellipsis; //显示 ...
    	white-space: nowrap; //不换
    }
    .myfont2 {
    	    word-break: break-all;
    	    text-overflow: ellipsis;
    	    display: -webkit-box;
    	    -webkit-box-orient: vertical;
    	    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    	    overflow: hidden;
    }
    .btnActive:active{
    	opacity: .6;
    	transition: all .2s;
    }

    ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 3px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 8px;
    }

    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      //background-color: #8c8c8c;
      background-color: rgba(0, 0, 0, 0.25);
    }

    ::-webkit-scrollbar-track {
      background-color: #f6f6f6;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-track {
      border: 0;
    }
    .emittxt{
      display: flex;
      justify-content: center;
      text-align: center;
      margin: 20px 0;
      padding-top: 20px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      font-size: 14px;
      color: #666666;
      // background-color: rgba(0, 0, 0, 0.1);
      height: 30px;
      line-height: 30px;
    }
    .contentlist{
      display: flex;
      width: 100%;
      max-width: 1200px;
      justify-content: space-between;
      background-color:#F7F8FA ;
      .left_box{
        width: 1200px;
        background: #FFFFFF;
        padding: 0 24px;
        height: calc(100vh - 80px - 64px);
        .userData{
        	display: flex;
          margin-bottom: 24px;
        	align-items: center;
        	.uheader{
        		width: 40px;
        		height: 40px;
        		border-radius: 50%;
        		margin-right:8px;
        		.uname{
        			color: #333;
        			display: flex;
        			flex-direction: column;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #B3B3B3;
        			.name{
        				font-size: 16px;
        				font-family: PingFangSC-Regular, PingFang SC;
        				font-weight: 400;
        				color: #333333;
        			}
        		}
        		img{
        			border-radius: 50%;
        			width: 40px;
        			height: 40px;
        		}
        	}
        }
        .art_title{
        	padding: 24px 0;
        	font-size:18px;
        	font-family: PingFangSC-Medium, PingFang SC;
        	font-weight: 600;
        	color: #333333;
        }

        .article_item:hover .title{
          color: #721EDC !important;
        }
        .article_item{
          height: 174px;
          padding:24px 0;
          box-sizing: border-box;
          cursor: pointer;
          display:flex;
          border-bottom: 1px solid rgba(0,0,0,0.1);
          .newsimg{
            margin-right: 12px;
            width: 224px;
            height: 126px;
            position: relative;
            img{
              object-fit: cover;
              background-size: cover;
              background-repeat: no-repeat;
              background-position: 50%;
              position: absolute;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .Lookuser{
       color: #999999 !important;
      }
      .right_box{
        width: 291px;
        margin-left:12px;
        box-sizing: border-box;
        box-sizing: border-box;
        .hot_infomations{
          background: #FFFFFF;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          height: calc(100vh - 80px - 136px);
          overflow-y: scroll;
          padding: 12px;
          box-sizing: border-box;
          .hot_infomations_item:hover{
            div{
              color: #721EDC !important;
            }
          }
          .hot_infomations_item{
            cursor: pointer;
            padding: 24px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            .newImage{
             width: 267px;
             height: 132px;
              background-color: rgba(0, 0, 0, 0.1);
              img{
                width: 267px;
                height: 132px;
              }
            }
            .Activearticle0{
              color: #ED1010 !important;
            }
            .Activearticle1{
              color: #E58000 !important;
            }
            .Activearticle2{
              color: #EDB210 !important;
            }
            .cont_txt{
              margin-top: 12px;
             font-size: 18px;
             font-family: PingFangSC-Medium, PingFang SC;
             font-weight: 500;
             color: #333333;
             display: flex;
             flex-direction: column;
             align-items: flex-start;
             span{
               margin-top: 6px;
               font-size: 12px;
               font-family: PingFangSC-Regular, PingFang SC;
               font-weight: 400;
               color: #B3B3B3;
             }
            }
            .numbers{
              width: calc(50px - 12px);
              line-height:44px;
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #DADADA;
            }
          }
        }
        .hot_title{
          display: flex;
          margin-right: 3px;
          padding: 0 12px;
          background-color: #FFFFFF;
          justify-content: space-between;
          align-items: center;
          span:nth-child(1){
            width: 80px;
            height: 60px;
            line-height: 60px;
            border-bottom: 2px solid #721EDC;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
          }
          span:nth-child(2){
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
      }
    }
  }
  .line_tabs{
    margin: 12px 0;
    max-width: 1200px;
    width: 100%;
    display: flex;
    padding:12px 24px;
    box-sizing: border-box;
    align-items: center;
    height: 40px;
    background: #FFFFFF;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;

    div{
      cursor: pointer;
    }
    div:hover{
      color: #721EDC;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/template/publicDetails.vue